module.exports = __webpack_public_path__ + "img/27.d74e114f.png";